import type { BlogNewsProp } from '@/services';

export const generatePostDate = (post: BlogNewsProp) =>
  new Date(post.date).toISOString().slice(2, 10).replace(/-/g, '. ');

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}/;

export const parseKSTDateFlag = (value: string | null): string | null =>
  value && DATE_REGEX.test(value) ? value : null;

/** 정렬용 epoch(ms). dateStr 이 비었거나 유효하지 않으면 0. */
export const toEpoch = (dateStr: string): number => {
  const time = new Date(dateStr).getTime();
  return Number.isNaN(time) ? 0 : time;
};
